import {
  Button,
  Classes,
  Dialog,
  Popover,
  Tooltip,
} from "@blueprintjs/core";
import { observer } from "mobx-react";
import * as React from "react";
import { copyToClipboard } from "../../../../utils";
import { toast } from "react-toastify";
import { BlockMath } from 'react-katex';
import { parse } from "mathjs";
import { AppIcon } from "../../../utils/AppIcon";
import { observable } from "mobx";
import { Editor } from "primereact/editor";

import 'katex/dist/katex.min.css';

interface Props {
  memoria_calculo: string;
  calcName: string;
  calc_vars: any[];
  nota_vars: any[];
  descritivo: string;
}

@observer
export class ItemMemoria extends React.Component<Props, {}> {

  obs = observable({
    open_descritivo: false as boolean
  })

  constructor(props) {
    super(props);
  }

  render() {

    const keyValueObj = this.props.memoria_calculo.split("\n").filter(x => x).reduce((acc, line) => {

      const [key, value] = line.split("=").map(s => s.trim());

      acc[key] = value;

      return acc;

    }, {});

    this.props.calc_vars.forEach(item => {

      let expr: any = item.expr

      expr.replace(/\b[A-Za-z_][A-Za-z0-9_]*\b/g, (match) => {

        if (!keyValueObj.hasOwnProperty(match)) {

          keyValueObj[match] = "0.00"

        }

      });

    })

    const formatToKaTeX = (input: string): string => {

      return parse(input).toTex({ parenthesis: "keep", implicit: "show" });

    }

    const renderContent = (campo: string) => {

      const item = this.props.calc_vars.find(x => x.nome == campo)

      if (item) {

        const nome = (item.nome || "").replace(/\_/g, "\\_");

        let expr: any = item.expr

        let exprSubstituida = expr.replace(/\b[A-Za-z_][A-Za-z0-9_]*\b/g, (match) => {

          return keyValueObj.hasOwnProperty(match) ? parseFloat(keyValueObj[match]).toFixed(2) : 0;

        });

        let substituted = formatToKaTeX(exprSubstituida)

        const exprFormat = formatToKaTeX(expr)

        const total = new Function(`return ${exprSubstituida}`)()

        return (

          <div key={item.order}>

            <div style={{ width: "max-content", float: "right" }}>
              <Tooltip content={"Clique para copiar a fórmula"}>
                <img style={{ cursor: "pointer" }} src='/images/copy.png' width={16} onClick={() => {
                  copyToClipboard(expr);
                  toast.success('Fórmula copiada', {});
                }} />
              </Tooltip>
            </div>

            <br />

            <span className="katex descricao-katex">{item.nome} = {item.descricao}</span>
            <BlockMath math={`${nome} = ${exprFormat}`} />
            <BlockMath math={`${nome} = ${substituted}`} />
            <BlockMath math={`${nome} = ${total.toFixed(2)}`} />

            <span style={{ color: "rgba(255, 0, 0, 0.82)" }}>
              Os valores apresentados podem variar em função do arredondamento das casas decimais.
            </span>

          </div>

        );

      } else {

        const item = this.props.nota_vars.find(x => x.nome == campo)

        if (item) {

          return (<span>{campo} = {item.descricao}</span>)

        }

      }

      return (<></>)

    }

    return (
      <>
        <div style={{ marginBottom: 10 }}>Cálculo aplicado: {this.props.calcName}
          {this.props.descritivo && <AppIcon name="help" className="pulse-notification-pgdas" color="blue" style={{ cursor: "pointer", marginLeft: 5 }} onClick={() => this.obs.open_descritivo = true} />}
        </div> 

        <div style={{ border: "1px solid rgba(27, 99, 111, 0.5)", borderRadius: 10, padding: 10, maxHeight: 400, overflow: "auto" }}>

          {Object.entries(keyValueObj).map(([campo, valor]) => (
            <>
              <Popover className="format-valores-calc">
                <span key={campo} style={{ cursor: "help" }} className="select-regras">{campo} = {parseFloat(valor.toString()).toFixed(2)}</span>

                <div style={{ padding: "20px" }}>

                  {renderContent(campo)}

                </div>

              </Popover>

              <br /><br />

            </>
          ))}

        </div>

        <Dialog isOpen={this.obs.open_descritivo} onClose={() => this.obs.open_descritivo = false} className="descritivo-calc">

          <div className={Classes.DIALOG_HEADER}>
            <span className="title-calculo">{this.props.calcName}</span>
          </div>

          <div className={Classes.DIALOG_BODY}>

            <Editor value={this.props.descritivo} style={{ height: '600px' }} showHeader={false} readOnly />

          </div>

          <div className={Classes.DIALOG_FOOTER}>

            <div className={Classes.DIALOG_FOOTER_ACTIONS}>

              <Button text="Fechar" intent="primary" onClick={() => this.obs.open_descritivo = false} />

            </div>

          </div>

        </Dialog>

      </>

    );
  }
}
